<div class="leave-confirmation-wrapper">
  <p class="leave-confirmation-icon">👋</p>
  <p class="leave-confirmation-heading">{{'leave-confirmation.See' | translate}}</p>
  <p class="leave-confirmation-content">
    {{'leave-confirmation.left' | translate}}
    <span class="leave-confirmation-strong-content"> [syndicate <br />name]. </span>
  </p>
  <ion-button class="go-to-syndicate-btn">{{'leave-confirmation.Go' | translate}}</ion-button>
</div>